import type { ComponentProps } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

type WebsiteCtaLinkProps = ComponentProps<typeof Link> & {
  fullWidth?: boolean;
  size?: "default" | "hero";
};

export function WebsiteCtaLink({ children, className, fullWidth = false, size = "default", ...props }: WebsiteCtaLinkProps) {
  return (
    <Link
      className={cn(
        "group inline-flex items-center justify-center gap-2 rounded-full bg-purple-600 font-semibold text-white shadow-[0_12px_30px_rgba(168,85,247,0.28)] transition-[background-color,transform,box-shadow] duration-200 ease-out hover:bg-purple-500 active:translate-y-px active:bg-purple-700",
        size === "hero" ? "px-7 py-4 text-lg md:px-8 md:text-xl" : "px-5 py-3 text-base md:px-6",
        fullWidth && "w-full",
        className,
      )}
      {...props}
    >
      <span>{children ?? "Start Now"}</span>
      <ArrowRight className={cn("shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 group-active:translate-x-0.5", size === "hero" ? "h-5 w-5" : "h-4 w-4")} />
    </Link>
  );
}